import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/cold-networking-email-generator/NetworkingEmailContent.tsx");
